// extracted by mini-css-extract-plugin
export default {"page":"styles_page__jj2Zw","searchRow":"styles_searchRow__KhAlk"};